export default (roomId) =>
  new Promise((resolve, reject) => {
    window.axios
      .get(`${process.env.VUE_APP_API_ADMIN_LOCATION}chat/room/${roomId}/message`, {
        headers: {
          ignoreLoading: true,
        },
      })
      .then(({ data }) => {
        let messages = {};
        if (data) {
          messages = data.messages;
        }
        resolve(messages);
      })
      .catch((error) => {
        reject(error);
      });
  });
